type HandoffLocation = Pick<Location, "hash" | "pathname" | "search">;
type HandoffHistory = Pick<History, "replaceState" | "state">;

export function consumeAuthCode(location: HandoffLocation, history: HandoffHistory): string | null {
  const handoff = new URLSearchParams(location.hash.replace(/^#/, ""));
  if (!handoff.has("auth_code")) return null;

  const authCode = handoff.get("auth_code");
  handoff.delete("auth_code");
  const remainingHash = handoff.toString();
  history.replaceState(
    history.state,
    "",
    `${location.pathname}${location.search}${remainingHash ? `#${remainingHash}` : ""}`,
  );
  return authCode || null;
}
